import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

interface PageSizeDropdownProps {
    pageSize: number;
    onPageSizeChange: (size: number) => void;
}

export const PageSizeDropdown = ({
    pageSize,
    onPageSizeChange,
}: PageSizeDropdownProps) => {
    const pageSizes = [10, 100, 500];

    return (
        <Menu>
            <MenuButton
                as={Button}
                size="sm"
                rightIcon={<ChevronDownIcon />}
                width="80px"
            >
                {pageSize}
            </MenuButton>
            <MenuList maxH="160px" overflowY="auto" minW="80px" maxW="80px">
                {pageSizes.map((size) => (
                    <MenuItem key={size} onClick={() => onPageSizeChange(size)}>
                        {size}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};